import { render, staticRenderFns } from "./DAGNode.vue?vue&type=template&id=4bd1a5ac&"
import script from "./DAGNode.vue?vue&type=script&lang=ts&"
export * from "./DAGNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports